//GLOBAL - components from npm
import React from "react";

//STYLES
import "./field-container.css";

//COMPONENTS
import Typography from "../Typography/index";

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...

export default function FieldContainer({
  className = "",
  title,
  children = "content example",
  orientation,
  required,
  requiredText = "*",
  htmlFor,
  icon,
  titleSize = "medium", // small || medium || large
  disabled,
  width
}) {
  //GENERAL

  //STATES

  //REDUX - Selectors

  //FUNCTIONS
  function renderTitle() {
    switch (titleSize) {
      case "small":
        return (
          <Typography.H6
            className="field-container__title"
            color="gray-600"
            weight="400"
          >
            {title}
            {required ? (
              <span className="symbol-warning">{requiredText}</span>
            ) : (
              ""
            )}
          </Typography.H6>
        );

      case "medium":
        return (
          <Typography.H5
            className="field-container__title"
            color="gray-600"
            weight="400"
          >
            {title}
            {required ? (
              <span className="symbol-warning">{requiredText}</span>
            ) : (
              ""
            )}
          </Typography.H5>
        );

      case "large":
        return (
          <Typography.H4
            className="field-container__title"
            color="black"
            weight="bold"
          >
            {title}
            {required ? (
              <span className="symbol-warning">{requiredText}</span>
            ) : (
              ""
            )}
          </Typography.H4>
        );

      default:
        break;
    }
  }

  //USE EFFECTS

  return (
    <label
      style={{ pointerEvents: disabled ? "none" : "", width: width && width }}
      htmlFor={htmlFor}
      className={`field-container ${className} ${orientation === "horizontal" ? "field-container--horizontal" : ""}`}
    >
      {title && (
        <div className="field-container__header">
          {icon && (
            <div className="field-container__icon-container">{icon}</div>
          )}
          {renderTitle()}
        </div>
      )}
      {children}
    </label>
  );
}
